import { Outlet, createRootRoute, createRootRouteWithContext } from "@tanstack/react-router";
import { SonnerToaster, Toaster } from "shadcn-ui";
import "../../lib/firebase"
import { NuqsAdapter } from "nuqs/adapters/tanstack-router"
import type { ContextRouter } from "../router";

export const Route = createRootRouteWithContext<ContextRouter>()({
	component: () => (
		<>
			<NuqsAdapter>
				<Outlet />
				<SonnerToaster />
				<Toaster />
			</NuqsAdapter>
		</>
	),
});
